export default __webpack_public_path__ + "static/media/18.4d8ba80b.jpg";